import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Avatar, Badge, Button, Divider, ListItemIcon, Menu, MenuItem, ListItem, Box, Typography } from "@mui/material";
import { Logout, Settings } from "@mui/icons-material";
import gorroNavidad from '../../img/gorro_navidad.png';
import { UsuarioContext } from "../../providers/personaContext";
import { clearCache } from "../../../funciones/apiCache";
import { limpiarDestinoRetorno } from "../../../funciones/rutaRetorno";
import { limpiarVentana } from "../../../funciones/ventanaSegundoFactor";

/* El mismo mapa que la ficha y las tablas: el TONO lo decide el servidor, el color es cosa
 * de la pantalla. */
const COLOR_PUNTO = { verde: '#16a34a', azul: '#2563eb', ambar: '#d97706', gris: '#94a3b8' };

/**
 * ── TU PROPIO PUNTO, JUNTO A TU NOMBRE ────────────────────────────────────────────────────
 *
 * Tiene un sentido que los otros no: **te dice cómo te ve el resto**. Si tienes vacaciones
 * aprobadas para hoy y no te acordabas, aquí lo ves.
 *
 * Con texto y no sólo color, igual que en las tablas: un punto de color a secas es un dato que
 * no está para quien no los distingue ni para quien usa un lector de pantalla.
 *
 * Y sin insignia no se pinta hueco: `null` es «no se dice», que no es lo mismo que gris.
 */
function MiPunto({ insignia }) {
  if (!insignia) return null;
  return (
    <span
      role="img"
      aria-label={'Tu situación: ' + insignia.texto}
      title={'Tu situación: ' + insignia.texto}
      style={{
        display: 'inline-block', width: 9, height: 9, borderRadius: '50%', marginRight: 6,
        backgroundColor: COLOR_PUNTO[insignia.tono] || COLOR_PUNTO.gris, flexShrink: 0,
      }}
    />
  );
}

const UserMenu = (props) => {
  const { persona, imgPerfil, insignia } = useContext(UsuarioContext);
  const navigate = useNavigate();
  const [anchorElUserMenu, setAnchorElUserMenu] = useState(null);
  const openUserMenu = Boolean(anchorElUserMenu);

  const gorraDeNavidad = () => {
    const hoy = new Date();
    const mesActual = hoy.getMonth(); 
    const diaActual = hoy.getDate();

    // Del 1 de diciembre al 6 de enero (inclusive)
    const esDiciembre = mesActual === 11 && diaActual >= 1;
    const esEneroYAntesDel7 = mesActual === 0 && diaActual <= 6;

    return esDiciembre || esEneroYAntesDel7;
  };

  const handleClickUserMenu = (event) => {
    setAnchorElUserMenu(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUserMenu(null);
  };
    const cerrarSesion = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("lastActivity");
    localStorage.removeItem("numActivo");
    clearCache();

    // Logout explícito: se descarta cualquier destino pendiente y NO se propaga
    // `from`. Cerrar sesión a propósito debe llevar a un login limpio; el
    // siguiente inicio aterriza en /panel-inicio, no en la última ruta.
    limpiarDestinoRetorno();
    // Fase A1 · y la ventana del segundo factor. Si alguien sale y otro entra en la MISMA
    // pestaña, no debe heredar una ventana abierta sobre datos sensibles.
    limpiarVentana();

    props.setAutenticado(false);
    navigate("/login", { replace: true });
  };

  const obtenerIniciales = () => {
    if (persona) {
      const nombre = persona.nombre || "";
      const apellidos = persona.apellidos || "";
      const iniciales = (nombre.charAt(0) + (apellidos.split(" ")[0]?.charAt(0) || "")).toUpperCase();
      return iniciales;
    }
    return "NL";
  };  return (
    <>
      <Button
        variant="text"
        onClick={handleClickUserMenu}
        size="small"
        sx={{ ml: props.isMobile ? 0 : 2, px: 1, minWidth: 0, color: '#33383b' }}
        aria-controls={openUserMenu ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={openUserMenu ? 'true' : undefined}
      >
        <Box sx={{ position: 'relative', display: 'inline-block' }}>
          {gorraDeNavidad() && (
            <img
              src={gorroNavidad}
              alt="Gorro de Navidad"
              style={{
                position: 'absolute',
                top: '-15px',
                left: '61%',
                transform: 'translateX(-50%)',
                width: '40px',
                height: 'auto',
                zIndex: 1000,
              }}
            />
          )}
          <Badge
            overlap="circular"
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}

          >
            <Avatar sx={{ width: 32, height: 32, fontSize: 16, mr: props.isMobile ? 0 : 1.5 }}>
              {imgPerfil ? (
                <img src={imgPerfil} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              ) : (
                obtenerIniciales()
              )}
            </Avatar>
          </Badge>
        </Box>
        {!props.isMobile && (
          <Box sx={{display: 'flex', flexDirection: 'column', textAlign: 'left', lineHeight: 1.3, mr: 6}}>
            <span>
              <MiPunto insignia={insignia} />
              {persona ? persona.nombre + " " + persona.apellidos : "No logueado"}
            </span>
          </Box>
        )}
      </Button>
      <Menu
        anchorEl={anchorElUserMenu}
        id="account-menu"
        open={openUserMenu}
        onClose={handleCloseUserMenu}
        onClick={handleCloseUserMenu}
        style={{
          
          marginLeft:props.isMobile ? "-20px" : ""
        }}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1.5,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        
        <Divider sx={{my: 1}}/>
        
        <>
          <ListItem sx={{flexDirection: 'column', alignItems: 'start', fontSize: 12, mb: 1}}>
            <Typography color='primary'>Sesión iniciada como</Typography>
            {persona ? persona.rol : 'No logueado'}
            {/* Aquí cabe el texto entero: el punto de la barra dice el color, esto dice qué es. */}
            {insignia && (
              <span style={{ display: 'inline-flex', alignItems: 'center', marginTop: 4 }}>
                <MiPunto insignia={insignia} />
                {insignia.texto}
              </span>
            )}
          </ListItem>
          <Divider  sx={{my: 1}}/>
        </>
        <MenuItem onClick={() => navigate("/perfil")}>
          <ListItemIcon>
            <Settings fontSize="small" />
          </ListItemIcon>
          Perfil
        </MenuItem>
        
 
          <MenuItem onClick={(e) => {cerrarSesion();}}>
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            Cerrar sesión
          </MenuItem>
        
      </Menu>
    </>
  )
}

export default UserMenu